import React from "react";
import { CCard, CCardBody, CCol, CRow, CBadge, CButton } from "@coreui/react";
import { cilPencil, cilPlus } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { useNavigate } from "react-router-dom";

const SellerAddressSection = ({ addresses }) => {
  const navigate = useNavigate();
  // console.log("Addresses:", addresses);
  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0 text-primary">Saved Addresses</h4>
        {addresses.length === 0 && (
          <CButton
            color="primary"
            size="sm"
            onClick={() => navigate("/seller/address")}
          >
            <CIcon icon={cilPlus} className="me-2" />
            Add New Address
          </CButton>
        )}
      </div>

      <CRow className="gy-4">
        {addresses.map((addr, index) => (
          <CCol md={6} key={index}>
            <CCard
              className={`rounded-4 shadow-sm border-0 h-100 ${
                addr.isDefault ? "bg-info-subtle" : "bg-light"
              }`}
            >
              <CCardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0 text-primary fw-semibold">
                    {addr.address_type} Address
                  </h6>
                  <div className="d-flex align-items-center gap-2">
                    {addr.isDefault === 1 ? (
                      <CBadge color="success">Default</CBadge>
                    ) : null}
                    <CIcon
                      icon={cilPencil}
                      className="me-1 cursor-pointer"
                      onClick={() =>
                        navigate(`/seller/address/${addr.id}`, {
                          state: { address: addr },
                        })
                      }
                    />
                  </div>
                </div>

                <CRow className="gy-2">
                  <CCol xs={12}>
                    <p className="text-muted mb-1 fw-semibold">Address</p>
                    <p className="mb-0 text-dark">
                      {addr.addressLine1}
                      {addr.addressLine2 ? `, ${addr.addressLine2}` : ""}
                    </p>
                  </CCol>
                  <CCol xs={6}>
                    <p className="text-muted mb-1 fw-semibold">City</p>
                    <p className="mb-0 text-dark">{addr.city}</p>
                  </CCol>
                  <CCol xs={6}>
                    <p className="text-muted mb-1 fw-semibold">State</p>
                    <p className="mb-0 text-dark">{addr.state}</p>
                  </CCol>
                  <CCol xs={6}>
                    <p className="text-muted mb-1 fw-semibold">Postal Code</p>
                    <CBadge color="info" className="fs-6 px-2">
                      {addr.postal_code}
                    </CBadge>
                  </CCol>
                  <CCol xs={6}>
                    <p className="text-muted mb-1 fw-semibold">Country</p>
                    <p className="mb-0 text-dark">{addr.region}</p>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        ))}
      </CRow>
    </div>
  );
};

export default SellerAddressSection;
